export const PAY = '[Pay]';

export const POST_PAY = `${PAY} Post`;
export const POST_PAY_EMBEDDED = `${PAY} Post Embedded`;
export const SET_PAY_EMBEDDED_DATA = `${PAY} Set Embedded Data`;

export const postPay = ({ query, form, url_pay }) => ({
    type: POST_PAY,
    payload: {
        data: query,
        body: { ...form, ...url_pay },
    },
});

export const postPayEmbedded = ({ query, form, url_pay }) => ({
    type: POST_PAY_EMBEDDED,
    payload: {
        data: query,
        body: { ...form, ...url_pay },
    },
});

export const setPayEmbeddedData = (data) => ({
    type: SET_PAY_EMBEDDED_DATA,
    payload: data,
});
